<!-- YF AI Trade — marka yazisi (frequi AppText override). Gold YF + yesil AI + Trade. -->
<template>
  <span class="text-xl text-nowrap font-bold"><span style="color: #bf9b4f">YF</span> <span style="color: #28a17a">AI</span> Trade</span>
</template>
